module.exports = __webpack_public_path__ + "static/media/infoDeclara.90de16fb.png";